import * as React from 'react'
import renderHTML from 'react-html-parser'
import clsx from 'clsx'
import { map } from 'lodash'
import Link from 'next/link'

import Icon from '~/truck/icon'
import Label from '~/truck/label'

import { Container } from './elements'

interface ItemProps {
  label?: string
  route?: string
}

interface BreadcrumbProps {
  items: ItemProps[]
  productIsAvailable: boolean
}

const Breadcrumb = (props: BreadcrumbProps) => {
  const { items, productIsAvailable } = props

  const renderItem = (item: ItemProps, index: number) => {
    const { label, route } = item

    if (!label) {
      return null
    }

    const isLast = index === items.length - 1

    if (isLast) {
      return (
        <Label key={label} $textStyle="h5Semibold" $ellipsis>
          {renderHTML(label)}
        </Label>
      )
    }

    const disabled = route !== '/' && !productIsAvailable

    return (
      <React.Fragment key={label}>
        <Link href={route} className={clsx(disabled && 'text-gray-400')}>
          {label}
        </Link>
        <Icon type="caret-right" color="black" />
      </React.Fragment>
    )
  }

  return <Container>{map(items, renderItem)}</Container>
}

export default Breadcrumb
